import { BusinessAppointmentConfigs, TBusiness } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function getBusinessQueueConfig({
  businessId,
  docIds,
  slot_config,
}: {
  businessId: TBusiness["business_id"];
  docIds?: string[];
  slot_config?: boolean;
}): Promise<TrystGenericResponse<BusinessAppointmentConfigs>> {
  try {
    const myHeaders = new Headers();
    if (docIds) {
      myHeaders.append("doc-ids", docIds.join(","));
    }

    const requestOptions: RequestInit = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      mode: "cors",
      credentials: "include",
    };
    const TRYST_HOST = GET_TRYST_HOST();

    let requestUrl = new URL(
      `${TRYST_HOST}/business/${businessId}/queue-config`
    );

    if (slot_config) {
      requestUrl.searchParams.set("slot_config", "true");
    }

    const response = await fetch(requestUrl.toString(), requestOptions);
    return await response.json();
  } catch (error) {
    console.error(error);
    return {
      success: false,
    };
  }
}
